/**
 * OpenIddict OAuth 2.0 Configuration
 *
 * The auth server (OpenIddict) is co-located with the API, so the authority
 * URL is derived directly from the resolved API URL in environment.ts.
 * This ensures each tenant subdomain authenticates against its own origin:
 *   Dev:  blackrock.motrv2.com:44368
 *   UAT:  blackrock.mot-r.app
 *   Prod: blackrock.mot-r.co
 */
import { config } from './environment';
import { APP_BASE_PATH } from './app.config';

/**
 * Get the auth authority URL.
 * Falls back to the API URL since auth and API are co-located.
 */
const getAuthAuthority = (): string => {
  // Allow override via environment variable
  if (import.meta.env.VITE_AUTH_AUTHORITY) {
    return import.meta.env.VITE_AUTH_AUTHORITY;
  }
  // Auth server is co-located with API
  return `${config.apiUrl}/`;
};

export const authConfig = {
  authority: getAuthAuthority(),
  client_id: import.meta.env.VITE_AUTH_CLIENT_ID || 'motr_App',
  // Always use current origin — supports tenant subdomains automatically
  redirect_uri: import.meta.env.VITE_AUTH_REDIRECT_URI || `${window.location.origin}${APP_BASE_PATH}`,
  post_logout_redirect_uri: `${window.location.origin}${APP_BASE_PATH}`,
  response_type: 'code',
  scope: 'offline_access motr openid profile email',
  automaticSilentRenew: true,
  silentRequestTimeoutInSeconds: 30,
  loadUserInfo: true,
} as const;
